import type {BlobPayload, DataRouterFilePagePayload} from '@github-ui/code-view-types'
import React from 'react'

export type CurrentBlob = Omit<BlobPayload, 'colorizedLines' | 'rawLines' | 'stylingDirectives'> &
  Partial<Pick<DataRouterFilePagePayload, 'codeLineWrapEnabled'>>

const CurrentBlobContext = React.createContext({} as CurrentBlob)

export function CurrentBlobProvider({blob, children}: React.PropsWithChildren<{blob: CurrentBlob}>) {
  return <CurrentBlobContext value={blob}> {children} </CurrentBlobContext>
}

export function useCurrentBlob() {
  return React.use(CurrentBlobContext)
}
